module.exports = __webpack_public_path__ + "settings.d57d51bbc247cfa8096c.svg";


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/assets/images/settings.svg
// module id = ../../../../../src/assets/images/settings.svg
// module chunks = styles